import React from 'react'
import { Container, Trip } from '../../types/container'
import { Modal } from '../ui/Modal/Modal'
import { ModalHeader } from '../ui/Modal/ModalHeader'
import { ModalBody } from '../ui/Modal/ModalBody'
import { Table } from '../ui/Table/Table'
import { TableHeader } from '../ui/Table/TableHeader'
import { TableRow } from '../ui/Table/TableRow'
import { TableCell } from '../ui/Table/TableCell'

export interface TripModalProps {
  container: Container | null
  isOpen: boolean
  onClose: () => void
}

export const TripModal: React.FC<TripModalProps> = ({ container, isOpen, onClose }) => {
  if (!container) {
    return null
  }

  const trips = container.trips

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        title={`Containers: ${container.number}`}
        onClose={onClose}
      />
      <ModalBody>
        {trips.length === 0 ? (
          <div className="text-center text-gray-500 py-8">
            Geen containers gevonden
          </div>
        ) : (
          <Table>
            <TableHeader columns={1}>
              <TableCell>Containernummer</TableCell>
            </TableHeader>

            {trips.map((trip: Trip) => (
              <TableRow key={trip.id} columns={1}>
                <TableCell truncate>{trip.containerNumber || trip.containerNumber1 || '-'}</TableCell>
              </TableRow>
            ))}
          </Table>
        )}
      </ModalBody>
    </Modal>
  )
}
